document.addEventListener('importTargetFolderChanged', event => {
    document.querySelectorAll('[data-import-into-label]').forEach(element => {
        element.textContent = element.dataset.importIntoLabel.replace('%s', event.detail.name);
    });
});
